import * as React from 'react';
import type { SVGProps } from 'react';
const SvgApplicationinprogressbadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#999" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#F2A218"
        d="M5.4 20.4q-.743 0-1.271-.529A1.73 1.73 0 0 1 3.6 18.6V5.4q0-.743.529-1.271A1.73 1.73 0 0 1 5.4 3.6h4.275q.2-.776.838-1.287Q11.15 1.8 12 1.8t1.488.513.837 1.287H18.6q.743 0 1.271.529.53.528.53 1.271v13.2q0 .743-.53 1.271a1.73 1.73 0 0 1-1.27.529zm0-1.8h13.2V5.4h-1.8v2.1a.87.87 0 0 1-.259.641.87.87 0 0 1-.64.26H8.1a.87.87 0 0 1-.642-.26A.87.87 0 0 1 7.2 7.5V5.4H5.4zm6.595-13.2a.88.88 0 0 0 .643-.257.86.86 0 0 0 .262-.638.88.88 0 0 0-.257-.642.86.86 0 0 0-.638-.263.88.88 0 0 0-.642.257.86.86 0 0 0-.263.638q0 .38.257.643a.86.86 0 0 0 .638.262"
      />
    </g>
  </svg>
);
export default SvgApplicationinprogressbadge;
